import { z } from "zod";
import { DipaiModuleEnum } from "./types.js";
import { zArr, zBool, zNum, zObj, zOptional, zStr } from "./zodWrapper.js";
export var ColumnType;
(function (ColumnType) {
    ColumnType["Fixed"] = "fixed";
    ColumnType["VarText"] = "var text";
    ColumnType["Select"] = "select";
    ColumnType["VarBool"] = "var bool";
    ColumnType["MultiSelect"] = "multi select";
    ColumnType["Table"] = "table";
})(ColumnType || (ColumnType = {}));
export const ColumnTypeEnum = z.nativeEnum(ColumnType);
export const Cell = zObj({ value: zStr(), disabled: zOptional(zBool()) });
export const Alternative = zObj({ value: zStr(), label: zStr() });
export const Column = zObj({
    cells: zArr(Cell),
    label: zStr(),
    type: ColumnTypeEnum,
    alternatives: zOptional(zArr(Alternative)),
});
export var ConfigurationModule;
(function (ConfigurationModule) {
    ConfigurationModule["AisDataSources"] = "AisDataSources";
    ConfigurationModule["Asset"] = "Asset";
    ConfigurationModule["BlueCtrl"] = "BlueCtrl";
    ConfigurationModule["Clarify"] = "Clarify";
    ConfigurationModule["ClarifyPlant"] = "ClarifyPlant";
    ConfigurationModule["ConfigSchemas"] = "ConfigSchemas";
    ConfigurationModule["DataEditor"] = "DataEditor";
    ConfigurationModule["Devices"] = "Devices";
    ConfigurationModule["DofDataSender"] = "DofDataSender";
    ConfigurationModule["DofOpModeNotifier"] = "DofOpModeNotifier";
    ConfigurationModule["FuelConsumerDataSheet"] = "FuelConsumerDataSheet";
    ConfigurationModule["FuelConsumption"] = "FuelConsumption";
    ConfigurationModule["Hoglund"] = "Hoglund";
    ConfigurationModule["HybridPropulsion"] = "HybridPropulsion";
    ConfigurationModule["KIMS"] = "K-IMS";
    ConfigurationModule["Inmarsat"] = "Inmarsat";
    ConfigurationModule["Misc"] = "Misc";
    ConfigurationModule["OpMode"] = "OpMode";
    ConfigurationModule["OpModePages"] = "OpModePages";
    ConfigurationModule["OpModeSchemas"] = "OpModeSchemas";
    ConfigurationModule["Plants"] = "Plants";
    ConfigurationModule["PropellerLinePower"] = "PropellerLinePower";
    ConfigurationModule["ReportFuel"] = "ReportFuel";
    ConfigurationModule["Seaq"] = "SeaQ";
    ConfigurationModule["Sensor"] = "Sensor";
    ConfigurationModule["SensorGroup"] = "SensorGroup";
    ConfigurationModule["SensorState"] = "SensorState";
    ConfigurationModule["Unit"] = "Unit";
    ConfigurationModule["User"] = "User";
    ConfigurationModule["VirtualSensors"] = "VirtualSensors";
    ConfigurationModule["Weather"] = "Weather";
    ConfigurationModule["MovingAvgSensors"] = "MovingAvgSensors";
    ConfigurationModule["SumSensors"] = "SumSensors";
    ConfigurationModule["DataSheetInterpolation"] = "DataSheetInterpolation";
    ConfigurationModule["DataSheetInterpolationSheets"] = "DataSheetInterpolationSheets";
    ConfigurationModule["EIAPPTableFuelRateComputer"] = "EIAPPTableFuelRateComputer";
    ConfigurationModule["EIAPPTableFuelRateComputerSheets"] = "EIAPPTableFuelRateComputerSheets";
    ConfigurationModule["PlantIntervalMarks"] = "PlantIntervalMarks";
    ConfigurationModule["SensorExpression"] = "SensorExpression";
    ConfigurationModule["SensorExpressionTerms"] = "SensorExpressionTerms";
    ConfigurationModule["Wartsila"] = "Wartsila";
})(ConfigurationModule || (ConfigurationModule = {}));
export const ConfigurationModuleEnum = z.nativeEnum(ConfigurationModule);
export const TableDbEditingWidget = zObj({
    columns: zArr(Column),
    label: zStr(),
    pushAllProperties: zBool(),
    reloadAfterPush: zBool(),
    rowIdentifiers: zArr(zStr()),
    description: zOptional(zStr()),
    includeCreationButton: zOptional(zBool()),
});
export const TableDbEditingWidgets = zArr(TableDbEditingWidget);
export const Property = zObj({ key: zStr(), value: zStr() });
export const TableObject = zObj({ properties: zArr(Property), object: zStr() });
export const ConfigurateDbArgs = zObj({
    objects: zArr(TableObject),
    module: ConfigurationModuleEnum,
    table: zStr(),
    key: zOptional(zStr()),
});
export const GetConfigWidgetsArgs = zObj({
    module: ConfigurationModuleEnum,
    key: zOptional(zStr()),
});
export const GetAllPlantsArgs = zObj({
    module: zOptional(DipaiModuleEnum),
    companyId: zOptional(zNum()),
});
export const OpModeSchemas = zArr(zObj({ name: zStr() }));
export const DbConfigurationKeys = zArr(zStr());
export const GetDbConfigurationKeysArgs = zObj({ module: ConfigurationModuleEnum });
export const DbConfigCreateObjectArgs = zObj({
    module: ConfigurationModuleEnum,
    table: z.string(),
    key: zOptional(zStr()),
});
//# sourceMappingURL=config.js.map